import { render } from "./App.vue?vue&type=template&id=5d464c76&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5d464c76&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=5d464c76&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d464c76"]])

export default __exports__